import { useSearchParams } from 'react-router-dom';
import { updateToken } from '@durma-soft/gros-sdk';
import { FC, ReactNode, useEffect, useState } from 'react';

import { LOCAL_STORAGE_TOKEN_KEY } from '@/config/global/storage';

export const ExternalLoginMiddleware: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get(LOCAL_STORAGE_TOKEN_KEY);

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (isLoaded) return;
    if (!token) {
      setIsLoaded(true);
      return;
    }
    const decodedToken = decodeURIComponent(token);
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, decodedToken);
    updateToken(decodedToken);
    setIsLoaded(true);
    searchParams.delete(LOCAL_STORAGE_TOKEN_KEY);
  }, [token, isLoaded, searchParams]);

  if (!token || isLoaded) {
    return <>{children}</>;
  }

  return null;
};
